import { useEffect, useState } from 'react';
import { FaWhatsapp } from 'react-icons/fa6';
import styles from './WhatsappFloat.module.css';

const typingSequence = ['digitando.', 'digitando..', 'digitando...'] as const;

export default function WhatsappFloat() {
  // visible: widget appears on the page after a delay (10s)
  const [visible, setVisible] = useState(false);
  // open: expanded bubble shown; when false widget hides
  const [open, setOpen] = useState(true);
  const [typingIndex, setTypingIndex] = useState(0);
  const [showMessage, setShowMessage] = useState(false);

  // show the whole widget after 10 seconds
  useEffect(() => {
    const showTimeout = window.setTimeout(() => {
      setVisible(true);
      setOpen(true);
    }, 10000);

    return () => window.clearTimeout(showTimeout);
  }, []);

  // when visible and open, run typing animation then show final message
  useEffect(() => {
    if (!visible || !open) return;

    setShowMessage(false);
    setTypingIndex(0);

    const typingInterval = window.setInterval(() => {
      setTypingIndex((prev) => (prev + 1) % typingSequence.length);
    }, 450);

    const messageTimeout = window.setTimeout(() => {
      setShowMessage(true);
      window.clearInterval(typingInterval);
    }, 2200);

    return () => {
      window.clearInterval(typingInterval);
      window.clearTimeout(messageTimeout);
    };
  }, [visible, open]);

  const handleOpenWhatsapp = () => {
    window.open('https://wa.me/5535999564940', '_blank', 'noopener,noreferrer');
  };

  if (!visible || !open) return null;

  return (
    <div className={styles.wrapper}>
      <button
        className={styles.closeButton}
        onClick={() => {
          setOpen(false);
          setVisible(false);
        }}
        aria-label="Fechar mensagem"
      >
        &times;
      </button>

      <div className={`${styles.bubble} ${showMessage ? styles.bubbleVisible : ''}`}>
        {showMessage ? (
          <span>Estou online! Converse comigo pelo WhatsApp.</span>
        ) : (
          <span className={styles.typing}>
            Digitando <strong>{typingSequence[typingIndex]}</strong>
          </span>
        )}
      </div>

      <button className={`${styles.fab} ${styles.vibrate}`} onClick={handleOpenWhatsapp} type="button" aria-label="Conversar pelo WhatsApp">
        <img src="/minhafoto.png" alt="Atendimento via WhatsApp" className={styles.avatar} />
        <span className={styles.whatsIcon}>
          <FaWhatsapp aria-hidden="true" />
        </span>
      </button>
    </div>
  );
}
